import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/declaracaoConcessionaria/';

class DeclaracaoConcessionariaService {
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (data ? data.token : '')
      };
    });
  }

  findAllDeclaracoes(idContribuinte, ano, mes) {
    return axios.get(API_URL + 'allDeclaracoes?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, { headers: this.headers });
  }

  declarar(idCliente, idUsuario, idContribuinte, ano, mes, tipo, declaracaoConcessionaria) {
    return axios.post(API_URL + 'declararConcessionaria?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes + '&tipo=' + tipo, JSON.stringify(declaracaoConcessionaria),
      { headers: this.headers });
  }

  encerrar(idCliente, idUsuario, idContribuinte, idDeclaracao) {
    return axios.post(
      API_URL +
      'encerrarDeclaracao?idCliente=' +
      idCliente +
      '&idContribuinte=' +
      idContribuinte +
      '&idUsuario=' +
      idUsuario +
      '&idDeclaracao=' +
      idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  cancelar(idUsuario, idContribuinte, idDeclaracao) {
    return axios.post(
      API_URL +
      'cancelar?idContribuinte=' +
      idContribuinte +
      '&idUsuario=' +
      idUsuario +
      '&idDeclaracao=' +
      idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  findBoletos(id) {
    return axios.get(API_URL + 'allBoletos?idDeclaracao=' + id, { headers: this.headers });
  }

  atualizarVencimento(idDeclaracao, dataVencimento) {
    return axios.post(
      API_URL + 'atualizarVencimento?idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento,
      null,
      { headers: this.headers },
    );
  }

  criarPagamentoPix(idDecLancamento, idDeclaracao) {
    return axios.post(
      API_URL + 'criarPagamentoPix?idDecLancamento=' + idDecLancamento + '&idDeclaracao=' + idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  criarPagamentoPixCp(idCalculoParcelado, idDeclaracao) {
    return axios.post(
      API_URL + 'criarPagamentoPixCp?idCalculoParcelado=' + idCalculoParcelado + '&idDeclaracao=' + idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  consultarPagamentoPix(idDeclaracao, idDamAgrupamento) {
    return axios.get(
      API_URL + 'consultarPagamentoPix?idDeclaracao=' + idDeclaracao + '&idDamAgrupamento=' + idDamAgrupamento,
      { headers: this.headers },
    );
  }

  upload(idCliente, idUsuario, idContribuinte, file) {
    const formData = new FormData()
    formData.append('file', file, file.name)
    return axios.post(API_URL + 'upload?idCliente=' + idCliente + '&idUsuario=' + idUsuario + '&idContribuinte=' + idContribuinte, formData, { headers: this.headers });
  }

}


export default new DeclaracaoConcessionariaService();